<template>

    <div class="consent__page-container" v-show="showPage">

        <mq-layout v-show="showPage" class="full" mq="lg">

            <header-band
                :back="true"
                :blueCleanfox="true"
                :title="'Cleanfox'"
                @eventBack="back"
            ></header-band>

        </mq-layout>

        <div v-show="showPage && isOldVersion" class="consent__bloc">

            <mq-layout :mq="['sm', 'md']" class="consent__bloc-cancel">

                <div class="consent__btn-back" @click="back">

                    <img class="consent__img-cancel" src="/img/icons/arrow-left-grey.svg">

                </div>

                <a :href="computedMyDataUrl" class="consent__btn-my-data" target="_blank"
                   rel="noopener noreferrer nofollow">{{ $t('more_title') }}</a>

            </mq-layout>

            <img v-if="$mq === 'lg'" class="consent__img-hand" src="/img/icons/privacy-fill-green.svg">

            <h1 class="consent__title">{{ $t('consent_title') }}</h1>

            <div class="consent__bloc-text">
                <div class="consent__bloc-title">
                    <img class="consent__img-text" src="/img/icons/bolt-green.svg">
                    <div class="consent__subtitle">{{ $t('consent_functioning_title') }}</div>
                </div>
                <div class="consent__privacy-text">{{ $t('consent_functioning_description') }}</div>
            </div>


            <div class="consent__bloc-text">
                <div class="consent__bloc-title">
                    <img class="consent__img-text" src="/img/icons/chart-pie-green.svg">
                    <div class="consent__subtitle">{{ $t('consent_how_works_title') }}</div>
                </div>
                <div class="consent__privacy-text">{{ $t('consent_how_works_description') }}</div>
            </div>

            <div class="consent__bloc-text">
                <div class="consent__bloc-title">
                    <img class="consent__img-text" src="/img/icons/lock-green.svg">
                    <div class="consent__subtitle">{{ $t('consent_data_protected_title') }}</div>
                </div>
                <div class="consent__privacy-text">{{ $t('consent_data_protected_description') }}</div>
            </div>

            <a v-if="$mq === 'lg'" class="consent__my-data-link" :href="hrefMyData">{{ $t('consent_your_data') }}</a>


            <div class="consent__bottom-container">

                <div class="consent__bottom-check-bloc">

                    <div class="consent__bottom-checkbox-container">

                        <checkbox :checked="accepted" :consentStyle="true" @change="checkboxUpdate"></checkbox>

                    </div>

                    <markdown
                        :tags="['terms', 'privacy']"
                        :blank="true"
                        :color="'#5ea774'"
                        :text="text"
                        class="consent__bottom-check-text"
                        @trackEvent="mardownClick"
                    ></markdown>

                </div>

                <button
                    :class="{'consent__btn-accepted': accepted}"
                    class="btn btn-green consent__btn-next"
                    @click="loginPage"
                >{{ $t('consent_cta_continue') }}
                </button>

            </div>

        </div>

        <div class="new-consent" v-show="showPage && !isOldVersion">

            <div class="content">

                <div class="bloc-consent">

                    <h1>{{ $t('consent_title') }}</h1>

                    <markdown :text="$t('consent_cleanfox_subtitle_web')" class="paragraph"></markdown>
                </div>

                <div class="bloc-overflow">

                    <div class="subtitle">
                        <img src="/img/icons/chart-pie-green.svg">
                        <span>{{ $t('consent_how_works_title') }}</span>
                    </div>

                    <markdown :text="$t('consent_cleanfox__data_collection_web')" class="paragraph"></markdown>

                    <div class="gap"></div>

                    <div class="subtitle">
                        <img src="/img/icons/lock-green.svg">
                        <span>{{ $t('consent_data_protected_title') }}</span>
                    </div>

                    <markdown :text="$t('consent_cleanfox_protection')" class="paragraph"></markdown>

                </div>

                <div class="bloc-consent">

                    <button class="cta" @click="ctaNewConsent">{{ $t('consent_cleanfox_lets_go') }}</button>

                    <markdown :text="$t('consent_cleanfox_under_cta_web')" class="end-paragraph"></markdown>

                </div>
            </div>


        </div>

        <block-mobile-popup :provider="provider" @unblock="activeConsentPage"></block-mobile-popup>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Storage from '../helpers/storage'

import Auth from '../modules/auth'
import Firebase from '../modules/firebase'
import I18n from '../modules/i18n'
import Tag from '../modules/tag'
import Tracking from '../modules/tracking'
import UserFlow from '../modules/userFlow'

import BlockMobilePopup from '../components/loginFlow/BlockMobilePopup'
import Checkbox from '../components/inputs/Checkbox'
import HeaderBand from '../components/headers/HeaderBand'
import Markdown from '../components/Markdown'
import SessionStorage from '../helpers/sessionStorage'

export default {

    name: 'consent-page',
    components: {BlockMobilePopup, Checkbox, HeaderBand, Markdown},

    computed: {

        ...Vuex.mapGetters(['page']),

        computedMyDataUrl() {
            return `/${I18n.get(this)}/my-data.html`
        },

        termsLink() {
            return `/${I18n.get(this)}/terms.html`
        },

        privacyLink() {
            return `/${I18n.get(this)}/privacy.html`
        },

        text() {
            return this.$tc('consent_check_box_web', 0, {terms: this.termsLink, privacy: this.privacyLink})
        },
        hrefMyData() {
            return `/${I18n.get(this)}/my-data.html`
        },

        isOldVersion() {
            return this.abTestVersion === 'A'
        }

    },

    data() {
        return {
            provider: '',
            year: new Date().getFullYear(),
            utmSource: '',
            showPage: false,
            accepted: false,
            invalidGrant: false,
            abTestVersion: 'A'
        }
    },

    created() {

        window.addEventListener('keypress', this.pressEnter)

        this.provider = this.$route.query.provider
        this.invalidGrant = this.$route.query.ig
        this.utmSource = Tracking.getTracking().utm_source

    },

    async mounted() {

        this.getABTestVersion()

        // scroll top for Iphone
        window.scrollTo(0, 0)

        if (this.$mq === 'lg' || (this.provider !== '' && this.provider !== 'google' && this.provider !== 'outlook')) {

            this.activeConsentPage()

        }

    },

    methods: {

        activeConsentPage() {

            if (!this.showPage) {

                this.showPage = true

                UserFlow.setPage(this, 'consent')

                Tag.pageViewGA(this, 'consent')
            }
        },

        checkboxUpdate(value) {

            Tag.clickAmplitude(this, 'check_box')

            this.accepted = value

        },

        loginPage() {

            if (this.accepted) {

                Storage.setItem('acceptConsent', true)

                const lang = I18n.get(this)
                // event for consent page, no wait response
                Auth.validConsent(lang, SessionStorage.getItem('email'))
                    .catch(() => {
                    })

                Tag.clickAll(this, 'accept', this.provider, this.page, this.isOldVersion ? 'old' : 'new')
                Tag.firstProvider(this, this.provider)
                this.nextWithProvider(this.provider)
            }
        },

        mardownClick(eventName) {

            Tag.clickAmplitude(this, eventName)

        },

        nextWithProvider(provider) {

            this.disablePressEnter()

            this.$router.push({path: `/login/${provider}?ig=${this.invalidGrant}`})

        },

        back() {

            Tag.clickGA(this, 'back', this.provider)

            this.$router.push('/')

        },

        pressEnter(event) {
            const key = event.which || event.keyCode
            if (key === 13 && this.isOldVersion) {
                this.loginPage()
            }

        },

        disablePressEnter() {
            window.removeEventListener('keypress', this.pressEnter)
        },

        ctaNewConsent() {
            this.accepted = true
            this.loginPage()
        },

        async getABTestVersion() {
            // the default version is A
            let consentNiqWeb = await Firebase.getValue('consent_niq_web', Firebase.TYPES.NUMBER)

            if(typeof consentNiqWeb !== 'number' || consentNiqWeb > 100 || consentNiqWeb < 0) {
                consentNiqWeb = 0
            }

            const random = Math.floor(Math.random() * (100 + 1) + 0)

            if(random >= consentNiqWeb) {
                this.abTestVersion = 'B'
            } else {
                this.abTestVersion = 'A'
            }
        }
    },

    destroyed() {
        this.disablePressEnter()
    }
}
</script>

<style lang="scss" scoped>

.consent {

    &__page-container {
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            background-color: $timberwolf;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-image: url(/img/background/cards-desktop.svg);
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: cover;
            background-blend-mode: luminosity;
        }
    }

    &__bloc {
        display: flex;
        flex-direction: column;
        background-color: $white;
        max-width: 512px;
        align-items: center;
        padding-bottom: 200px;
        @media screen and (min-width: $above-tablet-length) {
            border-radius: 12px;
            height: fit-content;
            padding: 0;
        }
    }

    &__img-hand {
        margin-top: 24px;
        width: 48px;
        object-fit: contain;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 32px;
        }
    }

    &__img-text {
        width: 24px;
        min-width: 24px;
        object-fit: contain;
        margin-right: 8px;
    }

    &__title {
        margin: 32px 24px 8px;
        font-size: 20px;
        font-weight: bold;
        line-height: 1.2;
        color: $rifle;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 12px;
        }
    }

    &__space {
        margin-top: 20px;
    }

    &__bloc-text {
        margin: 25px 24px 0;
        text-align: start;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            margin: 25px 32px 0;
        }
    }

    &__bloc-title {
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    &__bloc-cancel {
        height: 56px;
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 1px 0 0 rgba(17, 17, 26, 0.1);
    }

    &__btn-back {
        display: flex;
        align-items: flex-end;
    }

    &__img-cancel {
        width: 24px;
        object-fit: contain;

        &:lang(ar-sa) {
            transform: rotate(180deg);
        }
    }

    &__btn-my-data {
        border-radius: 32px;
        background-color: $mint;
        padding: 4px 12px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.28px;
        color: $rifle;
        display: flex;
        align-items: center;
        justify-content: center;
        height: fit-content;
    }

    &__subtitle {
        text-align: start;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.29;
        color: $rifle;
    }

    &__privacy-text {
        text-align: start;
        font-size: 15px;
        font-weight: 500;
        line-height: 1.4;
        color: $moon;
        margin-top: 7px;
    }

    &__my-data-link {
        font-size: 15px;
        font-weight: bold;
        line-height: 1.4;
        color: $forest;
        text-decoration: underline;
        margin-top: 24px;
    }

    &__bottom-container {
        position: fixed;
        bottom: 0px;
        left: 0;
        width: 100%;
        background-color: $white;
        border-top: 1px $silver solid;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 24px;
        @media screen and (min-width: $above-tablet-length) {
            position: relative;
            border-top: none;
            padding: 32px;
            border-radius: 12px;
        }
    }

    &__bottom-check-bloc {
        display: flex;
        flex-direction: row;
        align-items: center;
        text-align: start;
        width: 100%;
    }

    &__bottom-checkbox-container {
        width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__bottom-check-text {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.33;
        color: $stone;
        margin-left: 8px;

        &:lang(ar-sa) {
            margin-left: 0;
            margin-right: 8px;
        }
    }

    &__btn-next {
        width: 100%;
        margin-top: 24px;
        height: 51px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        color: $stone;
        background-color: $timberwolf;
    }

    &__btn-accepted {
        color: $white;
        background-color: $forest;
    }

}

//v2
.new-consent {
    height: 100vh;
    padding: 30px 20px 50px;
    background-color: $forest;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: $moon;
    flex: 1;
    display: flex;
    text-align: start;
    align-items: center;

    @media screen and (min-width: $above-tablet-length) {
        background: unset;
    }

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        background-color: $white;
        border-radius: 16px;
        padding-top: 4px;
        max-width: 512px;
        max-height: 95vh;
        @media screen and (min-width: $above-tablet-length) {
            height: fit-content;
        }

        .bloc-consent {
            padding: 16px;

            h1 {
                font-size: 20px;
                font-style: normal;
                font-weight: 700;
                line-height: 28px;
                color: $rifle;
            }

            .cta {
                width: 100%;
                min-height: 56px;
                padding: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $aquamarine;
                border-radius:32px;
                font-size: 17px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
                color: $white;
            }
        }

        .bloc-overflow {
            border: 1px solid $silver;
            padding: 16px;
            flex: 1;
            overflow-y: scroll;
            @media screen and (min-width: $above-tablet-length) {
                flex: none;
            }

            .gap {
                height: 16px;
            }
        }

        .paragraph {
            margin-top: 4px;
        }

        .end-paragraph {
            margin-top: 8px;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
        }

        .subtitle {
            color: $rifle;
            font-size: 17px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            display: flex;
            align-content: center;

            > img {
                width: 20px;
                object-fit: contain;
                margin-right: 4px;
            }
        }
    }

}

</style>
